import { ISetSessionActionPayload } from '../interfaces/set-session.action-payload.interface';

export class SetSession {
    static readonly type = '[Auth] SetSession';

    constructor(public payload: ISetSessionActionPayload) {}
}
